export const getArchiveWidgetData = (state) => state.archiveWidget;
export const getIsArchiveWidgetAdapterEnabled = (state) => getArchiveWidgetData(state).enabled;
